// extracted by mini-css-extract-plugin
export default {"recos":"o6-z","productCardOverride":"p6-z","rowHasBadge":"q6-z"};